import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Navbar from "@/components/sections/Navbar";
import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import Process from "@/components/sections/Process";
import Differentiators from "@/components/sections/Differentiators";
import Founder from "@/components/sections/Founder";
import Testimonials from "@/components/sections/Testimonials";
import Booking from "@/components/sections/Booking";
import FAQ from "@/components/sections/FAQ";
import Footer from "@/components/sections/Footer";

import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import { SiteContentProvider } from "@/lib/siteContent";
import Gallery from "@/components/sections/Gallery";
import Pricing from "@/components/sections/Pricing";

const Landing = () => {
  return (
    <main className="App">
      <Navbar />
      <Hero />
      <About />
      <Process />
      <Differentiators />
      <Founder />
      <Gallery />
      <Testimonials />
      <Pricing />
      <Booking />
      <FAQ />
      <Footer />
    </main>
  );
};

function App() {
  return (
    <SiteContentProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
        <Toaster richColors position="top-center" closeButton />
      </BrowserRouter>
    </SiteContentProvider>
  );
}

export default App;
